export default "__VITE_ASSET__BLQvMZZz__"